<button
  class="btn"
  type="button"
  role="button"
  [attr.title]="alt()"
  [b2cTooltip]="content()"
  [b2cTooltipHideDelay]="80"
  [b2cTooltipShowDelay]="120"
  [style.width]="width()"
  [b2cTooltipPosition]="position()"
>
  <img [src]="icon()" [alt]="alt()" class="tooltip-icon" />
</button>
